import { Icon } from "@iconify/react/dist/iconify.js";
import { FormControlLabel, FormHelperText, Grid, Radio } from "@mui/material";
import React from "react";

export default function InventoryType({ formObj, handleFormChange, error, handleVehicleObjChange }) {

    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const types = [
        {
            id: 'new',
            name: 'New Motorcycle',
            description: 'List a brand-new motorcycle unit directly from your inventory. '
        },
        {
            id: 'used',
            name: 'Used Motorcycle',
            description: 'Post a used motorcycle by selecting from your registered plate numbers.'
        },
        {
            id: 'rental',
            name: 'For Rent',
            description: 'Advertise motorcycles available for rent. Include pricing details and rental terms.'
        },
    ]
    return (
        <React.Fragment>
            {
                error?.inventory_type &&
                <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.inventory_type || ""}</FormHelperText>
            }
            <Grid container spacing={2} mt={1}>
                {
                    types.map((type, index) => (
                        <Grid item md={6} sm={12} xs={12}>
                            <div className={`${formObj?.inventory_type === type.id ? 'dashboard-selected-card' : 'dashboard-card'} d-flex align-items-center clickable`} style={{ minHeight: 120 }} onClick={() => { handleFormChange('inventory_type', type.id); handleVehicleObjChange && handleVehicleObjChange('colour_text', null) }}>
                                <Grid container spacing={2}>
                                    <Grid item lg={11} sm={10} xs={9}>
                                        <div className="">{type?.name || '-'}</div>
                                        <div className="subheader-2">{type?.description || '-'}</div>
                                    </Grid>
                                    <Grid item lg={1} sm={2} xs={3} className="d-flex align-items-center justify-content-end">
                                        <FormControlLabel
                                            checked={formObj?.inventory_type === type.id}
                                            value={type.id}
                                            onClick={() => { handleFormChange('inventory_type', type.id); handleVehicleObjChange && handleVehicleObjChange('colour_text', null) }}
                                            key={index}
                                            style={{ fontFamily: 'FunnelSans', fontSize: 14, margin: 0 }}
                                            control={<Radio
                                                sx={{
                                                    '&.Mui-checked': {
                                                        color: "#1D1B1B",
                                                    },
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: 20,
                                                    },

                                                }} />}
                                        />
                                    </Grid>
                                </Grid>
                            </div>
                        </Grid>
                    ))
                }
            </Grid>
        </React.Fragment>
    )
}